<mat-list-item [class.expand]="isExpanded" (click)="onLogout()">
  <mat-icon mat-list-icon>exit_to_app</mat-icon>
  <ng-container *ngIf="isExpanded">
    <h3 mat-subheader [ngStyle]="{ 'font-size': fontSize }">{{ 'dsLibCommon.login.disconnect' | translate }}</h3>
  </ng-container>
</mat-list-item>
